import React from "react";
import "./StoreTag.scss";
class StoreTag extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filter: props.tag,
      type: props.type ? props.type : "Community Relation",
      onChange: props.onTagClicked,
    };
    this.onStoreTagClicked = this.onStoreTagClicked.bind(this);
  }
  render() {
    return (
      <button
        onClick={this.onStoreTagClicked}
        className={this.props.tagClass ? this.props.tagClass : "storeTag"}
      >
        {this.props.tag}
      </button>
    );
  }
  onStoreTagClicked(e) {
    this.props.onTagClicked(this.state);
  }
}
export default StoreTag;
